import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-nome',
  templateUrl: './text-nome.component.html',
  styleUrls: ['./text-nome.component.scss'],
  viewProviders: [ParentFormGroup ]
})
export class TextNomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {} 
}
